var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "userSelect-container" },
    [
      _c(
        "div",
        { staticClass: "userSelect-input", on: { click: _vm.openDialog } },
        [
          _c(
            "el-input",
            {
              attrs: {
                placeholder: _vm.placeholder,
                readonly: "",
                disabled: _vm.disabled,
              },
              model: {
                value: _vm.innerValue,
                callback: function ($$v) {
                  _vm.innerValue = $$v
                },
                expression: "innerValue",
              },
            },
            [
              _vm.clearable
                ? _c("i", {
                    staticClass: "el-input__icon el-icon-circle-close",
                    attrs: { slot: "suffix" },
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        return _vm.clear($event)
                      },
                    },
                    slot: "suffix",
                  })
                : _vm._e(),
              _c("i", {
                staticClass: "el-input__icon el-icon-arrow-down",
                class: { clearable: _vm.clearable },
                attrs: { slot: "suffix" },
                slot: "suffix",
              }),
            ]
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "Weforsys-dialog Weforsys-dialog_center transfer-dialog",
          attrs: {
            title: "选择用户",
            "close-on-click-modal": false,
            visible: _vm.visible,
            "lock-scroll": "",
            "append-to-body": "",
            width: "800px",
            "modal-append-to-body": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "transfer__body",
              attrs: { "element-loading-text": _vm.$t("common.loadingText") },
            },
            [
              _c("div", { staticClass: "transfer-pane" }, [
                _c(
                  "div",
                  { staticClass: "transfer-pane__tools" },
                  [
                    _c(
                      "el-input",
                      {
                        attrs: { placeholder: "输入关键词进行搜索" },
                        nativeOn: {
                          keyup: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.getList($event)
                          },
                        },
                        model: {
                          value: _vm.keyword,
                          callback: function ($$v) {
                            _vm.keyword = $$v
                          },
                          expression: "keyword",
                        },
                      },
                      [
                        _c("el-button", {
                          attrs: { slot: "append", icon: "el-icon-search" },
                          on: { click: _vm.getList },
                          slot: "append",
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "transfer-pane__body" },
                  [
                    _c("el-tree", {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.loading,
                          expression: "loading",
                        },
                      ],
                      staticClass: "Weforsys-common-el-tree",
                      attrs: {
                        data: _vm.treeData,
                        props: _vm.props,
                        "highlight-current": "",
                        "expand-on-click-node": false,
                        "check-on-click-node": "",
                        "node-key": "id",
                        lazy: "",
                        load: _vm.loadNode,
                      },
                      on: { "node-click": _vm.handleNodeClick },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (ref) {
                            var node = ref.node
                            var data = ref.data
                            return _c(
                              "span",
                              { staticClass: "custom-tree-node" },
                              [
                                _c("i", { class: data.icon }),
                                _c("span", { staticClass: "text" }, [
                                  _vm._v(_vm._s(node.label)),
                                ]),
                              ]
                            )
                          },
                        },
                      ]),
                    }),
                  ],
                  1
                ),
              ]),
              _c("div", { staticClass: "transfer-pane" }, [
                _c(
                  "div",
                  { staticClass: "transfer-pane__tools" },
                  [
                    _c("span", [_vm._v("已选")]),
                    _c(
                      "el-button",
                      { attrs: { type: "text" }, on: { click: _vm.removeAll } },
                      [_vm._v("清空列表")]
                    ),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "transfer-pane__body shadow right-pane" },
                  [
                    _vm._l(_vm.selectedData, function (item, index) {
                      return _c(
                        "div",
                        { key: index, staticClass: "selected-item" },
                        [
                          _c("span", [_vm._v(_vm._s(item.fullName))]),
                          _c("i", {
                            staticClass: "el-icon-delete",
                            on: {
                              click: function ($event) {
                                return _vm.removeData(index)
                              },
                            },
                          }),
                        ]
                      )
                    }),
                  ],
                  2
                ),
              ]),
            ]
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.visible = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("common.cancelButton")))]
              ),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.confirm } },
                [_vm._v(_vm._s(_vm.$t("common.confirmButton")))]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }